import { createSlice } from "@reduxjs/toolkit";
import { sessionService } from "redux-react-session";
import { BASE_API_URL } from "../constants";
import { runAuthenticatedActions, runUnauthorizedActions } from "./loginSlice";

const accountSlice = createSlice({
	name: "account",
	initialState: {
		isLoading: false,
		redirectUrl: "/home",
	},
	reducers: {
		requestAccountData(state) {
			state.isLoading = true;
		},
		receiveAccountData(state) {
			state.isLoading = false;
		},
		setRedirectUrl(state, action) {
			state.redirectUrl = action.payload.redirectUrl;
		},
	},
});

export const { requestAccountData, receiveAccountData, setRedirectUrl } = accountSlice.actions;

export const fetchAccount = () => async (dispatch) => {
	sessionService
		.loadSession()
		.then((session) => {
			let headers = {
				Authorization: "bearer " + session.loginData.access_token,
				"Content-Type": "application/json",
			};
			let options = {
				method: "GET",
				headers: headers,
			};
			dispatch(requestAccountData());
			let responseStatus = 0;
			return fetch(BASE_API_URL + "/api/Cuenta/MiCuenta", options)
				.then((response) => {
					responseStatus = response.status;
					if (response.ok) {
						return response.json();
					} else {
						return Promise.reject(
							"El usuario o la contraseña son incorrectos."
						);
					}
				})
				.then((json) => {
					sessionService
						.saveUser({ user: json })
						.then()
						.catch((error) => console.log("error", error));
					dispatch(receiveAccountData());
					dispatch(runAuthenticatedActions());
				})
				.catch((error) => {
					// TODO: fetch error actions
					// If 401 Unauthorized login failed
					if (responseStatus === 401) {
						dispatch(runUnauthorizedActions());
					}
				});
		})
		.catch((err) => console.log("Error", err));
};

export default accountSlice.reducer;
